import { jsx as _jsx } from "react/jsx-runtime";
import { ModalStackContext } from '#pplx/frontend/aether/components/Modal/context/ModalStackContext.js';
import { ModalStateRenderer } from '#pplx/frontend/aether/modals/internal/ModalStateRenderer.js';
import { useModalStore } from '#pplx/frontend/aether/modals/store/useModalStore.js';
import { memo, useMemo } from 'react';
const selector = (store) => ({
    modalIds: store.stack,
    modalMap: store.modals,
});
export const GlobalModalRenderer = memo(function GlobalModalRenderer({ logger }) {
    const { modalIds, modalMap } = useModalStore(selector);
    const modalStates = useMemo(() => {
        const states = Array.from(modalIds)
            .map((id) => {
            const modalState = modalMap.get(id);
            if (!modalState) {
                logger.warn(`Modal with id ${id} not found in store.`);
                return null;
            }
            return modalState;
        })
            .filter((modal) => !!modal);
        return states;
    }, [modalIds, modalMap, logger]);
    return modalStates.map((modalState, index) => {
        return (_jsx(ModalStackContext.Provider, { value: index, children: _jsx(ModalStateRenderer, { modalState: modalState }) }, modalState.id));
    });
});
//# sourceMappingURL=GlobalModalRenderer.js.map